import dayjs from 'dayjs';
import { t } from 'i18next';
import * as yup from 'yup';

import { MAX_RANGE_DAYS } from './utils';

export const uomConversionAuditSchema = () =>
  yup.object({
    dateFrom: yup.mixed().nullable().label(t('labelDateFrom')),
    dateTo: yup
      .mixed()
      .nullable()
      .label(t('labelDateTo'))
      .test(
        'uomAuditDateRange',
        t('messageInvalidDateRangeMaxDays', { maxDays: MAX_RANGE_DAYS }),
        function (value) {
          const { dateFrom } = this.parent;

          if (!value || !dateFrom) {
            return true;
          }

          const from = dayjs(dateFrom);
          const to = dayjs(value);

          return (
            !to.isBefore(from, 'day') && !to.isAfter(from.add(MAX_RANGE_DAYS - 1, 'day'), 'day')
          );
        }
      ),
  });
